import axiosPublicClient from "../../../../axiosPublicClient"

const service = async (data) => {
    const result = await axiosPublicClient.post(`/submit-pre-check-consent`, data)

    return result.data
}

export default service
